import React from 'react';
import {MoreExpandListDetail} from '../MoreExpandListDetail/MoreExpandListDetail';
import {MoreExpandListItem} from '../MoreExpandListItem/MoreExpandListItem';
import {MoreExpandListProps} from './MoreExpandListProps.interface';

// TODO : 단순히 item과 detail을 합친 컴포넌트로 따로 정의할 필요는 없어 제거 요망 (공지사항, 도움말 수정이 필요합니다.) - bill 리뷰
const MoreExpandList = React.memo(
  React.forwardRef<HTMLElement, MoreExpandListProps>(
    ({isActive, id, title, createDt, contents, onClick}, ref) => {
      return (
        <>
          <MoreExpandListItem
            ref={ref}
            isActive={isActive}
            id={id}
            title={title}
            createDt={createDt}
            onClick={onClick}
          />
          <MoreExpandListDetail isActive={isActive} contents={contents} />
        </>
      );
    }
  )
);

MoreExpandList.displayName = 'MoreExpandList';

export {MoreExpandList};
